import { FormEvent, useEffect, useState } from 'react';
import { Check, Loader2 } from 'lucide-react';

export const UnsubscribePage = () => {
  const [token, setToken] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');
  useEffect(() => setToken(new URLSearchParams(window.location.search).get('token') || ''), []);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setState('sending');
    try {
      const response = await fetch('/api/leads/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (!response.ok) throw new Error('unsubscribe failed');
      setState('done');
    } catch {
      setState('error');
    }
  };

  return (
    <main id="top" className="as-unsubscribe-page">
      <div>
        <p className="as-descriptor">Préférences e-mail</p>
        <h1>Arrêter les conseils de suivi.</h1>
        {state === 'done' ? (
          <div className="as-lead-success" role="status"><Check size={20} /><div><strong>Désinscription enregistrée.</strong><p>Aucun autre conseil automatique ne sera envoyé à cette adresse.</p></div></div>
        ) : (
          <form onSubmit={submit}>
            <p>Confirmez pour annuler les e-mails J+3/J+7 associés à cette adresse. Les messages nécessaires à une demande client distincte ne sont pas concernés.</p>
            {state === 'error' && <p className="as-form-error" role="alert">La demande n’a pas pu être enregistrée. Vous pouvez nous contacter depuis le formulaire du site.</p>}
            {!token && <p className="as-form-error">Le lien est incomplet.</p>}
            <button className="as-button as-button-dark" type="submit" disabled={!token || state === 'sending'}>
              {state === 'sending' ? <><Loader2 className="as-spinner" size={17} /> Enregistrement…</> : 'Confirmer la désinscription'}
            </button>
          </form>
        )}
      </div>
    </main>
  );
};
